function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.24219 16.875H3.75C3.58424 16.875 3.42527 16.8091 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V12.7578C3.12472 12.6766 3.14044 12.5962 3.17128 12.5212C3.20211 12.4461 3.24745 12.3778 3.30469 12.3203L12.6797 2.94531C12.7378 2.88625 12.8072 2.83936 12.8836 2.80735C12.9601 2.77534 13.0421 2.75885 13.125 2.75885C13.2079 2.75885 13.2899 2.77534 13.3664 2.80735C13.4428 2.83936 13.5122 2.88625 13.5703 2.94531L17.0547 6.42968C17.1137 6.48784 17.1606 6.55716 17.1927 6.63361C17.2247 6.71006 17.2411 6.79211 17.2411 6.87499C17.2411 6.95787 17.2247 7.03993 17.1927 7.11638C17.1606 7.19283 17.1137 7.26215 17.0547 7.3203L7.67969 16.6953C7.62216 16.7526 7.55391 16.7979 7.47884 16.8287C7.40376 16.8596 7.32335 16.8753 7.24219 16.875V16.875Z",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.625 5L15 9.375",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgPen = function SvgPen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Pen.f2d831d4.svg";
export { ForwardRef as ReactComponent };